<template>
  <div :class="focusedOnboardingFlow ? '' : 'form__group--border py-32'">
    <h2 v-if="!focusedOnboardingFlow" class="heading-2 mb-24">Write a bio</h2>
    <BioAreaNotebox class="-mt-16" :careType="careType" />
    <fieldset>
      <legend class="sr-only">Write a bio</legend>
      <TextArea
        id="bio"
        ref="textAreaComponent"
        v-model="bio"
        class="mt-16"
        labelName="Profile bio"
        :characterCounter="true"
        :minCharacters="150"
        :maxCharacters="2500"
        :rows="8"
      />
      <HelperText
        :status="helperStatus.Neutral"
        text="Note: your profile will be public, so don't share any personal details, like your contact information, last name, or links to your portfolio or social profiles."
        customClasses="leading-4"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import BioAreaNotebox from './BioAreaNotebox.vue';
import TextArea from '@/components/textarea/TextArea.vue';
import HelperText from '@/components/helper_text/HelperText.vue';
import focusOnElement from '@/helpers/focusHelper';
import helperStatus from '@/helpers/status';

export default {
  name: 'BioArea',
  components: { BioAreaNotebox, TextArea, HelperText },
  data(): any {
    return {
      careType: this.$store.state.sitterOnboarding.careType,
      showPopup: false,
      helperStatus,
    };
  },
  computed: {
    bio: {
      get() {
        return this.$store.getters.getFormField('bio');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'bio', value: newValue });
      },
    },
    focusedOnboardingFlow() {
      return window.location.pathname.includes('/profile/steps');
    },
    childrenOrPets(): string {
      return this.careType === 'petCare' ? 'pets' : 'children';
    },
  },
  methods: {
    validate() {
      this.$refs.textAreaComponent.checkValidation();

      return this.$refs.textAreaComponent.isValid;
    },
    focusElement() {
      focusOnElement(this.$refs.textAreaComponent.$el.querySelector('textarea'));
    },
  },
};
</script>
